var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{attrs:{"content":"Signed Off Deliverables","placement":"top"}},[_c('a',{staticClass:"btn btn-sm",attrs:{"href":_vm.link.sourceDownloadURL}},[_c('i',{staticClass:"fas fa-file-download mr-2"}),_vm._v("Download Zip ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }